import { VendorsPageWithTabs } from './VendorsPageWithTabs'
import { VendorsAbilityProvider } from './Providers'
import VendorsPagePopupProvider from './Providers/VendorsPagePopupProvider'

export const Vendors = () => {
  return (
    <VendorsAbilityProvider>
      <VendorsPagePopupProvider>
        <VendorsPageWithTabs />
      </VendorsPagePopupProvider>
    </VendorsAbilityProvider>
  )
}
